module.exports = __webpack_public_path__ + "static/media/gtdLogo.f5dc527a.svg";